import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createAccount } from '../../api';

export function useCreateAccount() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createAccount,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['accounts'] }),
  });
}
